import { generateClient } from "@aws-amplify/api";
import { Amplify } from "aws-amplify";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import amplifyconfig from "~/amplifyconfiguration.json";
import { singleFlightCredentialsProvider } from "~/auth/singleFlightCredentialsProvider";

// Configure in two passes on purpose. The first (no libraryOptions) lets
// aws-amplify wire up its default providers — crucially the user-pool token
// provider WITH its localStorage-backed token storage + auth config. Passing
// `libraryOptions.Auth` on the FIRST call makes aws-amplify's configure
// early-return before that default wiring runs (initSingleton), which would
// break token persistence.
Amplify.configure(amplifyconfig);

// Second pass swaps ONLY the Identity-Pool credentials provider for our
// single-flight wrapper (re-pointing at the already-initialized default token
// provider so it isn't dropped). This coalesces the GetCredentialsForIdentity
// stampede that every userPool GraphQL request would otherwise provoke — see
// singleFlightCredentialsProvider.ts.
Amplify.configure(amplifyconfig, {
  Auth: {
    tokenProvider: cognitoUserPoolsTokenProvider,
    credentialsProvider: singleFlightCredentialsProvider,
  },
});

export const amplifyGraphQLClient = generateClient({
  // Default to userPool auth mode
  authMode: "userPool",
});
